import React from 'react';
import { connect } from 'react-redux';

import { createStyles, Theme, withStyles } from '@material-ui/core/styles';
import { Grid, TextField } from '@material-ui/core';

import style from '../awbReturn.module.css';
import commonStyles from '../../../common/common.module.css';
import { ReturnReason } from '../../../../models/ReturnAwb';

const styles = (theme: Theme) =>

  createStyles({
    formControlLabel: {
      marginRight: '2%',
      '& p': {
        fontSize: '14px'
      }
    },
    label: {
      color: 'rgb(9, 43, 74)'
    }
  });

interface ReturnReasonComponentProps {
  classes: any;
  returnDetails: ReturnReason;
  handleChange: (type: string, event: any) => void;
  returnErrors: ReturnReason;
};

const returnReasonComponent = (props: ReturnReasonComponentProps) => {

  return (
    <div className={ `${commonStyles.wrapper} ${style.wrapper} ${commonStyles.h100}` }>
      <h3 className={`${commonStyles.header}`} >Return Details</h3>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={4} md={12} className={ style.returnReasonGridItems }>
          <TextField
            required
            id='reason'
            label='Reason for return'
            value={ props.returnDetails.reason }
            onChange={ (event) => props.handleChange('reason', event) }
            variant='outlined'
            fullWidth
            className={ commonStyles.customTextField }
            InputProps={{
              classes: {
                notchedOutline: `${ commonStyles.noNotch }`,
              },
            }}
            InputLabelProps={{
              shrink: true,
              className: commonStyles.customLabelProp,
            }}
            error={ props.returnErrors.reason !== '' }
            helperText={ props.returnErrors.reason !== '' ? props.returnErrors.reason + ' Reason' : '' }
          />
        </Grid>
        <Grid item xs={12} sm={4} md={6} className={ style.returnReasonGridItems }>
          <TextField
            required
            id='pieces'
            label='Pieces Returned'
            type='number'
            value={ props.returnDetails.pieces }
            onChange={ (event) => props.handleChange('pieces', event) }
            variant='outlined'
            fullWidth
            className={ commonStyles.customTextField }
            InputProps={{
              classes: {
                notchedOutline: ` ${ commonStyles.noNotch }`,
              },
            }}
            InputLabelProps={{
              shrink: true,
              className: commonStyles.customLabelProp,
            }}
            error={ props.returnErrors.pieces !== 0 }
            helperText={ props.returnErrors.pieces !== 0 ? props.returnErrors.pieces + ' Pieces' : ''}
          />
        </Grid>
        <Grid item xs={12} sm={4} md={6} className={ style.returnReasonGridItems }>
          <TextField
            required
            id='weight'
            label='Weight Returned'
            type='number'
            value={ props.returnDetails.weight }
            onChange={ (event) => props.handleChange('weight', event) }
            variant='outlined'
            fullWidth
            className={ commonStyles.customTextField }
            InputProps={{
              classes: {
                notchedOutline: ` ${ commonStyles.noNotch }`,
              },
            }}
            InputLabelProps={{
              shrink: true,
              className: commonStyles.customLabelProp,
            }}
            error={ props.returnErrors.weight !== 0 }
            helperText={ props.returnErrors.weight !== 0 ? props.returnErrors.weight + ' Weight' : ''}
          />
        </Grid>
      </Grid>
    </div>
  );
};

const mapStateToProps = (state: any) => {
  return {
    manualEntryEdit: state.manualEntryEdit,
    manualEntryAdd: state.manualEntryAdd
  };
}

export default withStyles(styles)(connect(mapStateToProps, {})(returnReasonComponent));
